import React from 'react';
import useUser from '../../hooks/useUser';
import CEOBillReports from './ceo/BillReports';
import AdminBillReports from './admin/BillReports';
import ManagerBillReports from './manager/BillReports';

const BillReports = () => {
    const { userRole } = useUser();

    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    // Render based on role
    if (roleLower === 'ceo') {
        return <CEOBillReports />;
    } else if (roleLower === 'admin') {
        return <AdminBillReports />;
    } else if (roleLower === 'manager') {
        return <ManagerBillReports />;
    } else {
        // Default to manager view if role is not recognized
        return <ManagerBillReports />;
    }
};

export default BillReports;
